import store from '@/store';
import { setSessionStorage } from './common';
import { Message } from 'view-design';
// const Base64 = require("js-base64").Base64;
import router from '../../router';
import { getMenuByUser, getBtnPerm, userLogin } from './sysAction';

// agent免登陆 处理登录cookie
const LoginMessage = () => {
    window.addEventListener('message', function(event) {
        if (event.data != undefined && typeof event.data === 'string') {
            window.opener.postMessage('success', '*');
            let CommData = new Object();
            // let data = Base64.decode(event.data);
            let data = event.data;
            data = JSON.parse(data);
            CommData.org_user_id = data.org_user_id;
            CommData.org_dept_id = data.org_dept_id;
            CommData.org_term_no = data.org_term_no;
            CommData.orguser_cn_name = data.orguser_cn_name;
            CommData.orgdept_cn_name = data.orgdept_cn_name;
            CommData.org_channel_code = data.org_channel_code;
            CommData.org_rs_code = data.org_rs_code;
            CommData.org_work_code = data.org_work_code;
            CommData.submit_type = data.submit_type;
            CommData.is_need_token = 1; // 登录成功之后  开启验证token
            CommData.token = data.token;

            // 浏览器存储登录信息
            setSessionStorage('CommData', JSON.stringify(CommData));
            store.commit('SET_COMMDATA', JSON.stringify(CommData));
            // 判断是否有主题编号
            data.theme &&
                data.theme != undefined &&
                setSessionStorage(
                    'ThemeInfo',
                    JSON.stringify({
                        themeId: data.theme,
                    })
                );
            NMG_skip(data);
        }
    });
};
// NMG 跳转方法
const NMG_skip = async data => {
    // 要跳转的路由信息
    let skipRouteInfo = {
        // 默认跳转到首页
        name: 'home',
        query: {},
        params: {},
    };
    // 判断是否有code平台码    有的话请求菜单 没有就不请求
    if (data.code && data.code != '') {
        await getMenuByUser(data.code);
        await getBtnPerm(data.code);
    }

    router.push(skipRouteInfo);
};

export default LoginMessage;
